import _styled from "styled-components";
var _class, _Timeline;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import dateFormat from "dateformat";
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import defined from "terriajs-cesium/Source/Core/defined";
import JulianDate from "terriajs-cesium/Source/Core/JulianDate";
import CommonStrata from "../../../Models/Definition/CommonStrata";
import withControlledVisibility from "../../HOCs/withControlledVisibility";
import CesiumTimeline from "./CesiumTimeline";
import { formatDateTime } from "./DateFormats";
import DateTimePicker from "./DateTimePicker";
import Styles from "./timeline.scss";
import TimelineControls from "./TimelineControls";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let Timeline = observer(_class = (_Timeline = class Timeline extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isPickerOpen: false
    };
  }
  componentDidMount() {
    this.props.terria.timelineStack.activate();
  }
  componentWillUnmount() {
    this.props.terria.timelineStack.deactivate();
  }
  changeDateTime(time) {
    this.props.terria.timelineClock.currentTime = JulianDate.fromDate(new Date(time));
    this.props.terria.timelineStack.syncToClock(CommonStrata.user);
    this.props.terria.currentViewer.notifyRepaintRequired();
  }
  onOpenPicker() {
    this.setState({
      isPickerOpen: true
    });
  }
  onClosePicker() {
    this.setState({
      isPickerOpen: false
    });
  }
  render() {
    const terria = this.props.terria;
    const catalogItem = terria.timelineStack.top;
    if (!defined(catalogItem) || !defined(catalogItem.currentTimeAsJulianDate)) {
      return null;
    }
    const {
      t
    } = this.props;
    const jsDate = JulianDate.toDate(catalogItem.currentTimeAsJulianDate);
    const timelineStack = this.props.terria.timelineStack;
    let currentTime;
    if (defined(timelineStack.top) && defined(timelineStack.top.dateFormat)) {
      currentTime = dateFormat(jsDate, this.props.terria.timelineStack.top.dateFormat);
    } else {
      currentTime = formatDateTime(jsDate, this.props.locale);
    }
    const discreteTimes = catalogItem.discreteTimesAsSortedJulianDates;
    const objectifiedDates = catalogItem.objectifiedDates;
    const currentDiscreteJulianDate = catalogItem.currentDiscreteJulianDate;
    return /*#__PURE__*/_jsxs("div", {
      className: Styles.timeline,
      children: [/*#__PURE__*/_jsx(_StyledDiv, {
        className: Styles.textRow,
        children: /*#__PURE__*/_jsxs("div", {
          className: Styles.textCell,
          title: t("dateTime.timeline.textCell"),
          children: [/*#__PURE__*/_jsx("div", {
            className: Styles.layerNameTruncated,
            children: catalogItem.name
          }), currentTime]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: Styles.controlsRow,
        children: [/*#__PURE__*/_jsx(TimelineControls, {
          clock: terria.timelineClock,
          analytics: terria.analytics,
          currentViewer: terria.currentViewer
        }), defined(discreteTimes) && discreteTimes.length !== 0 && defined(currentDiscreteJulianDate) && /*#__PURE__*/_jsx(DateTimePicker, {
          currentDate: JulianDate.toDate(currentDiscreteJulianDate),
          dates: objectifiedDates,
          onChange: () => this.changeDateTime(),
          openDirection: "up",
          isOpen: this.state.isPickerOpen,
          onOpen: () => this.onOpenPicker(),
          onClose: () => this.onClosePicker(),
          dateFormat: catalogItem.dateFormat
        }), /*#__PURE__*/_jsx(CesiumTimeline, {
          terria: terria
        })]
      })]
    });
  }
}, _defineProperty(_Timeline, "propTypes", {
  terria: PropTypes.object.isRequired,
  locale: PropTypes.object,
  t: PropTypes.func.isRequired
}), _Timeline)) || _class;
export default withControlledVisibility(withTranslation()(Timeline));
var _StyledDiv = _styled("div").withConfig({
  displayName: "Timeline___StyledDiv",
  componentId: "sc-jaud7z-0"
})(["background:", ";min-height:30px;"], p => p.theme.dark);